
<div class="row">
  <div class="col">
    <h2 class="draggable"><fa-icon [icon]="faMapMarkedAlt"></fa-icon> Sothus Abbey Ruins</h2>
  </div>
</div>

<div id="vttSvg" ></div>

